export enum InventoryItemType {
  PRODUCT = "PRODUCT",
  RAW_MATERIAL = "RAW_MATERIAL",
}

export enum StockHistoryView {
  TRANSACTIONS = "TRANSACTIONS",
  INVENTORY = "INVENTORY",
}
